import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box  from "@mui/material/Box";
import FavoriteIcon from "@mui/icons-material/Favorite";
import CommentIcon from "@mui/icons-material/Comment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import useBlogCall from "../../hooks/useBlogCall";

export default function BlogCard({ blog }) {
  const {
    id,
    title,
    content,
    image,
    author,
    post_views,
    comment_count,
    category_name,
    likes,
    likes_n,
  } = blog;

  const navigate = useNavigate();
  const { currentUser, currentUserID } = useSelector((state) => state.auth);

  const { postLikeComment } = useBlogCall();

  const handleLike = () => {
    postLikeComment("likes", id, "like", currentUserID);
  };

  const userID = likes_n.filter((item) => item.user_id === currentUserID);
 

  return (
    <Card
      sx={{
        p: 2,
        width: "500px",
        minHeight: "500px",
        maxHeight: "550px",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        mb: 1,
      }}
    >
      <CardMedia
        component="img"
        alt="green iguana"
        height="140"
        image={image}
        sx={{ height: 180, objectFit: "contain" }}
      />
      <CardContent>
        <Typography gutterBottom variant="h5" component="div">
          {title.charAt(0).toUpperCase()}
          {title.slice(1).toLowerCase()}
        </Typography>
        <Typography sx={{ fontSize: "0.8rem" }}>({category_name})</Typography>
        <Typography variant="body1" color="text.secondary">
          {content}
        </Typography>
      </CardContent>
      <CardContent sx={{ display: "flex" }}>
        <AccountCircleIcon />
        {author.charAt(0).toUpperCase()}
        {author.slice(1).toLowerCase()}
      </CardContent>

      <CardActions sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box>
          <Button
            size="small"
            sx={{ fontSize: "1.2rem" }}
            onClick={() => (currentUser ? handleLike() : navigate("login"))}
          >
            {!currentUser && <FavoriteIcon sx={{ color: "gray" }} />}
            {currentUser && (
              <FavoriteIcon
                sx={{ color: () => (userID?.length ? "red" : "gray") }}
              />
            )}
            {likes}
          </Button>
          <Button size="small" sx={{ fontSize: "1.2rem" }}>
            <CommentIcon sx={{ color: "gray" }} />
            {comment_count}
          </Button>
          <Button size="small" sx={{ fontSize: "1.2rem" }}>
            <VisibilityIcon sx={{ color: "gray" }} />
            {post_views}
          </Button>
        </Box>
        <Button
          onClick={() =>
            currentUser ? navigate(`/detail/${id}`) : navigate("login")
          }
          sx={{
            bgcolor: "blue",
            color: "white",
            "&:hover": { bgcolor: "red" },
            fontWeight: "800",
          }}
        >
          read more
        </Button>
      </CardActions>
    </Card>
  );
}
